<div class="flex-container ngx-data-table__footer"
  fxLayout="row">
  @if (displayFooterNote) {
    <div class="ngx-data-table__footerNote">
      {{ displayFooterNote }}
    </div>
  }
  <div class="flex-item"
    fxFlex
    fxLayoutAlign="end center"
    [ngClass]="{'ngx-data-table__mobile-footer': (isMobile || hidePageOptions())}">
    @if (!hidePageOptions()) {
      <span fxLayoutAlign="end center">
        <span>Page:</span>
        <mat-select class="ngx-data-table__pagination-dropdown ngx-data-table__arrow-wrapper"
          #pageDropdown
          data-testid="current-page-dropdown"
          [(ngModel)]="currentPage"
          (selectionChange)="changeCurrentPage(currentPage)">
          @for (page of pageNumberArr; track page; let i = $index) {
            <mat-option
              [value]="i" [attr.data-testid]="page + '-option'">
              {{page}}
            </mat-option>
          }
        </mat-select>
        <span>Rows per page:</span>
        <mat-select class="ngx-data-table__pagination-dropdown ngx-data-table__arrow-wrapper"
          #pageSizeDropdown
          [(ngModel)]="pageSize"
          data-testid="page-size-dropdown"
          (selectionChange)="pageSizeChange()">
          @for (size of pageSizeOptions; track size) {
            <mat-option
              [value]="size" [attr.data-testid]="size + '-option'">
              {{size}}
            </mat-option>
          }
        </mat-select>
      </span>
    }
    @if (( totalElements > 0)) {
      <pagination
        [totalElements]="totalElements"
        [pageSize]="pageSize"
        [currentPage]="currentPage"
        (pageRight)="pageRight()"
        (pageLeft)="pageLeft()">
      </pagination>
    }
  </div>
</div>
